// XLSX do relatório de uso da API: cabeçalho com período + uma linha por chamada.
import * as XLSX from "xlsx";
import { EXPORT_COLUMNS, buildExportRows } from "./apiReportRules";
import { i18n } from "../../translate/i18n";

const t = (k, o) => i18n.t(`aeros.apiReport.${k}`, o);
const br = (s) => (s ? s.split("-").reverse().join("/") : "");

export default function exportApiXlsx({ rows, dateFrom, dateTo }) {
  const columns = EXPORT_COLUMNS;
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([
    [t("sheetTitle")],
    [`${t("sheetStart")}: ${br(dateFrom)}`],
    [`${t("sheetEnd")}: ${br(dateTo)}`],
    [],
    columns.map((c) => c.label),
    ...buildExportRows(rows, columns),
  ]);
  ws["!merges"] = [{ s: { c: 0, r: 0 }, e: { c: columns.length - 1, r: 0 } }];
  ws["!cols"] = columns.map((c) => ({ wch: c.width || 15 }));
  XLSX.utils.book_append_sheet(wb, ws, t("sheetCalls"));
  XLSX.writeFile(wb, "uso-da-api.xlsx", { bookType: "xlsx" });
}
